// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"959278bd","643":"89a0b46c"}[chunkId] + ".chunk.js";
};